import React, { useState, useEffect, useCallback } from 'react';
import KernteamLayout from '../../KernteamLayout';
import BackArrow from '../../BackArrow';
import SuccessModal from '../../SuccessModal';
import { host_url } from '../../App';
import { CAMP_TAGE, aktuellerCampTag } from '../../campTage';
import '../ListenSubpage.css';
import './TagesablaufVerwaltung.css';

// Zeitachse wie auf dem gedruckten Tagesablaufblatt: 7 bis 24 Uhr
const START_STUNDE = 7;
const ENDE_STUNDE = 24;
const GESAMT_MINUTEN = (ENDE_STUNDE - START_STUNDE) * 60;

// Farbpalette, angelehnt an das gedruckte Tagesablaufblatt
const FARBEN = [
  { name: 'Dunkelblau', wert: '#1f4e9c' },
  { name: 'Hellblau', wert: '#29b6e8' },
  { name: 'Grün', wert: '#6ab023' },
  { name: 'Hellgrün', wert: '#a5cf4f' },
  { name: 'Gelb/Orange', wert: '#f0a202' },
  { name: 'Lachs', wert: '#f4713b' },
  { name: 'Rot', wert: '#d92b2b' },
  { name: 'Pink', wert: '#e0457b' },
  { name: 'Lila', wert: '#5e2b5e' },
  { name: 'Oliv', wert: '#a08c2a' },
];

// Standard-Tag nach dem Donnerstag des Tagesablaufblatts. Dient als Basis für
// neue Tage und kann danach frei angepasst werden.
const DONNERSTAG_VORLAGE = [
  { name: 'Weckradio', slots: [{ start: '07:30', ende: '08:00', farbe: '#29b6e8' }] },
  { name: 'Waschen, Zähneputzen…', slots: [{ start: '07:30', ende: '08:30', farbe: '#1f4e9c' }] },
  { name: 'Mahlzeiten', slots: [
    { start: '08:00', ende: '08:45', farbe: '#6ab023' },
    { start: '12:30', ende: '13:15', farbe: '#6ab023' },
    { start: '18:30', ende: '19:15', farbe: '#6ab023' },
  ] },
  { name: 'Kernteam-Besprechung', slots: [{ start: '09:00', ende: '09:30', farbe: '#5e2b5e' }] },
  { name: 'Betreuer_innen - Café', slots: [{ start: '09:30', ende: '23:00', farbe: '#f0a202' }] },
  { name: 'Agentur für Arbeit', slots: [
    { start: '10:00', ende: '12:30', farbe: '#e0457b' },
    { start: '13:30', ende: '16:30', farbe: '#e0457b' },
  ] },
  { name: 'Arbeitszeit für alle Kinder', slots: [
    { start: '10:00', ende: '12:30', farbe: '#f0a202' },
    { start: '13:30', ende: '16:30', farbe: '#f0a202' },
  ] },
  { name: 'Sparkasse', slots: [
    { start: '10:30', ende: '12:30', farbe: '#d92b2b' },
    { start: '14:00', ende: '17:00', farbe: '#d92b2b' },
  ] },
  { name: 'Zeltbetreuer_innen-Besprechg.', slots: [{ start: '10:00', ende: '10:30', farbe: '#f4713b' }] },
  { name: 'Parlament', slots: [{ start: '14:00', ende: '16:00', farbe: '#1f4e9c' }] },
  { name: 'Stadtstunde', slots: [{ start: '17:00', ende: '17:30', farbe: '#1f4e9c' }] },
  { name: 'Markt', slots: [{ start: '17:30', ende: '18:00', farbe: '#d92b2b' }] },
  { name: 'Logistiker_innen-Besprechung', slots: [{ start: '11:00', ende: '11:30', farbe: '#29b6e8' }] },
  { name: 'Freizeitangebote', slots: [
    { start: '10:00', ende: '10:30', farbe: '#a08c2a', label: 'Zumba' },
    { start: '19:30', ende: '20:30', farbe: '#a5cf4f' },
  ] },
  { name: 'Tagesschau (Stormini am Abend)', slots: [{ start: '21:30', ende: '22:00', farbe: '#f0a202' }] },
  { name: 'Arbeit-/Freizeit-Besprechung', slots: [{ start: '18:45', ende: '19:15', farbe: '#5e2b5e' }] },
  { name: 'Night chillen/Nachtruhe', slots: [{ start: '22:00', ende: '22:30', farbe: '#29b6e8' }] },
];

function zeitZuProzent(zeit) {
  const [h, m] = String(zeit).split(':').map(Number);
  const minuten = h * 60 + (m || 0) - START_STUNDE * 60;
  return Math.min(100, Math.max(0, (minuten / GESAMT_MINUTEN) * 100));
}

function TagesablaufVerwaltung() {
  const [tag, setTag] = useState(aktuellerCampTag());
  const [zeilen, setZeilen] = useState([]);
  const [vorhandeneTage, setVorhandeneTage] = useState([]);
  const [kopierQuelle, setKopierQuelle] = useState('');
  const [neueZeileName, setNeueZeileName] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [laedt, setLaedt] = useState(false);

  const fetchTage = useCallback(async () => {
    try {
      const res = await fetch(`${host_url}/tagesablauf/tage`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      setVorhandeneTage(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Fehler beim Laden der Tage:', err);
    }
  }, []);

  const fetchZeilen = useCallback(async () => {
    try {
      const res = await fetch(`${host_url}/tagesablauf?datum=${tag}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      setZeilen(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Fehler beim Laden des Tagesablaufs:', err);
      setZeilen([]);
    }
  }, [tag]);

  useEffect(() => { fetchTage(); }, [fetchTage]);
  useEffect(() => { fetchZeilen(); }, [fetchZeilen]);

  const api = async (pfad, method, body) => {
    const res = await fetch(`${host_url}${pfad}`, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
    });
    if (!res.ok) {
      const fehler = await res.json().catch(() => ({}));
      throw new Error(fehler.message || `HTTP ${res.status}`);
    }
    return res.json();
  };

  // ─── Tag anlegen: Vorlage / Kopie ───

  const vorlageAnwenden = async () => {
    setLaedt(true);
    try {
      for (const zeile of DONNERSTAG_VORLAGE) {
        const result = await api('/tagesablauf/zeilen', 'POST', { Datum: tag, Name: zeile.name });
        for (const slot of zeile.slots) {
          await api('/tagesablauf/slots', 'POST', {
            ZeileID: result.ID, Start: slot.start, Ende: slot.ende, Farbe: slot.farbe, Label: slot.label || null,
          });
        }
      }
      setSuccessMsg('Tag aus Donnerstag-Vorlage angelegt!');
      await fetchZeilen();
      await fetchTage();
    } catch (err) {
      console.error('Fehler beim Anwenden der Vorlage:', err);
      alert(`Fehler beim Anwenden der Vorlage: ${err.message}`);
    }
    setLaedt(false);
  };

  const tagKopieren = async () => {
    if (!kopierQuelle) return;
    setLaedt(true);
    try {
      await api('/tagesablauf/kopieren', 'POST', { vonDatum: kopierQuelle, nachDatum: tag });
      setSuccessMsg('Tag kopiert!');
      await fetchZeilen();
      await fetchTage();
    } catch (err) {
      console.error('Fehler beim Kopieren:', err);
      alert(`Fehler beim Kopieren: ${err.message}`);
    }
    setLaedt(false);
  };

  const tagLoeschen = async () => {
    if (!window.confirm('Wirklich den kompletten Tagesablauf dieses Tages löschen?')) return;
    try {
      await api(`/tagesablauf/tag/${tag}`, 'DELETE');
      setSuccessMsg('Tag gelöscht!');
      await fetchZeilen();
      await fetchTage();
    } catch (err) {
      console.error('Fehler beim Löschen des Tages:', err);
      alert(`Fehler beim Löschen: ${err.message}`);
    }
  };

  // ─── Zeilen ───

  const zeileHinzufuegen = async () => {
    if (!neueZeileName.trim()) return;
    try {
      await api('/tagesablauf/zeilen', 'POST', { Datum: tag, Name: neueZeileName.trim() });
      setNeueZeileName('');
      await fetchZeilen();
      await fetchTage();
    } catch (err) {
      alert(`Fehler beim Hinzufügen: ${err.message}`);
    }
  };

  const zeileLokalAendern = (zeileId, name) => {
    setZeilen((prev) => prev.map((z) => (z.ID === zeileId ? { ...z, Name: name } : z)));
  };

  const zeileSpeichern = async (zeile) => {
    try {
      await api(`/tagesablauf/zeilen/${zeile.ID}`, 'PUT', { Name: zeile.Name, Sortierung: zeile.Sortierung });
      setSuccessMsg('Zeile gespeichert!');
    } catch (err) {
      alert(`Fehler beim Speichern: ${err.message}`);
    }
  };

  const zeileLoeschen = async (zeile) => {
    if (!window.confirm(`Zeile "${zeile.Name}" samt allen Zeitslots löschen?`)) return;
    try {
      await api(`/tagesablauf/zeilen/${zeile.ID}`, 'DELETE');
      await fetchZeilen();
      await fetchTage();
    } catch (err) {
      alert(`Fehler beim Löschen: ${err.message}`);
    }
  };

  // Zeile nach oben/unten verschieben: Sortierung mit dem Nachbarn tauschen
  const zeileVerschieben = async (index, richtung) => {
    const nachbarIndex = index + richtung;
    if (nachbarIndex < 0 || nachbarIndex >= zeilen.length) return;
    const a = zeilen[index];
    const b = zeilen[nachbarIndex];
    let sortA = b.Sortierung;
    const sortB = a.Sortierung;
    // Falls beide Sortierungen identisch sind (z.B. Altdaten), bewusst versetzen
    if (sortA === sortB) sortA = sortB + richtung;
    try {
      await api(`/tagesablauf/zeilen/${a.ID}`, 'PUT', { Name: a.Name, Sortierung: sortA });
      await api(`/tagesablauf/zeilen/${b.ID}`, 'PUT', { Name: b.Name, Sortierung: sortB });
      await fetchZeilen();
    } catch (err) {
      alert(`Fehler beim Verschieben: ${err.message}`);
    }
  };

  // ─── Slots ───

  const slotHinzufuegen = async (zeile) => {
    try {
      await api('/tagesablauf/slots', 'POST', {
        ZeileID: zeile.ID, Start: '09:00', Ende: '10:00', Farbe: FARBEN[0].wert, Label: null,
      });
      await fetchZeilen();
    } catch (err) {
      alert(`Fehler beim Hinzufügen: ${err.message}`);
    }
  };

  const slotLokalAendern = (zeileId, slotId, feld, wert) => {
    setZeilen((prev) => prev.map((z) => {
      if (z.ID !== zeileId) return z;
      return {
        ...z,
        Slots: z.Slots.map((s) => (s.ID === slotId ? { ...s, [feld]: wert, dirty: true } : s)),
      };
    }));
  };

  const slotSpeichern = async (slot) => {
    if (!slot.Start || !slot.Ende) return;
    try {
      await api(`/tagesablauf/slots/${slot.ID}`, 'PUT', {
        Start: slot.Start, Ende: slot.Ende, Farbe: slot.Farbe, Label: slot.Label || null,
      });
      setSuccessMsg('Zeitslot gespeichert!');
      await fetchZeilen();
    } catch (err) {
      alert(`Fehler beim Speichern: ${err.message}`);
    }
  };

  const slotLoeschen = async (slot) => {
    try {
      await api(`/tagesablauf/slots/${slot.ID}`, 'DELETE');
      await fetchZeilen();
    } catch (err) {
      alert(`Fehler beim Löschen: ${err.message}`);
    }
  };

  const tagHatDaten = (datum) => vorhandeneTage.includes(datum);

  return (
    <KernteamLayout>
      <div className="container">
        <BackArrow to="/listen" />
        <h1 className="section-title blue">Tagesablauf</h1>

        {/* Tages-Tabs */}
        <div className="ta-admin-tabs">
          {CAMP_TAGE.map(({ datum, label }) => (
            <button
              key={datum}
              className={`ta-admin-tab ${tag === datum ? 'active' : ''}`}
              onClick={() => setTag(datum)}
            >
              {label}
              {tagHatDaten(datum) && <span className="ta-tab-punkt" />}
            </button>
          ))}
        </div>

        {zeilen.length === 0 ? (
          /* Noch kein Tagesablauf für diesen Tag: anlegen */
          <div className="ta-leer-panel">
            <p className="ta-leer-hinweis">
              Für diesen Tag ist noch kein Tagesablauf angelegt. Wie möchtest du starten?
            </p>
            <button className="btn-save" onClick={vorlageAnwenden} disabled={laedt}>
              <span className="material-symbols-outlined">content_paste</span>
              Donnerstag-Vorlage verwenden
            </button>
            {vorhandeneTage.filter((d) => d !== tag).length > 0 && (
              <div className="ta-kopieren-zeile">
                <select value={kopierQuelle} onChange={(e) => setKopierQuelle(e.target.value)}>
                  <option value="">Tag auswählen…</option>
                  {vorhandeneTage.filter((d) => d !== tag).map((d) => {
                    const campTag = CAMP_TAGE.find((t) => t.datum === d);
                    return <option key={d} value={d}>{campTag ? campTag.label : d}</option>;
                  })}
                </select>
                <button className="btn-save" onClick={tagKopieren} disabled={!kopierQuelle || laedt}>
                  <span className="material-symbols-outlined">content_copy</span>
                  Tag kopieren
                </button>
              </div>
            )}
            <p className="ta-leer-oder">… oder leer starten und unten die erste Zeile hinzufügen.</p>
          </div>
        ) : (
          <div className="ta-zeilen-liste">
            {zeilen.map((zeile, index) => (
              <div className="ta-zeile-card" key={zeile.ID}>
                <div className="ta-zeile-kopf">
                  <div className="ta-zeile-verschieben">
                    <button
                      className="ta-icon-btn"
                      title="Nach oben"
                      disabled={index === 0}
                      onClick={() => zeileVerschieben(index, -1)}
                    >
                      <span className="material-symbols-outlined">arrow_upward</span>
                    </button>
                    <button
                      className="ta-icon-btn"
                      title="Nach unten"
                      disabled={index === zeilen.length - 1}
                      onClick={() => zeileVerschieben(index, 1)}
                    >
                      <span className="material-symbols-outlined">arrow_downward</span>
                    </button>
                  </div>
                  <input
                    type="text"
                    className="ta-zeile-name"
                    value={zeile.Name}
                    onChange={(e) => zeileLokalAendern(zeile.ID, e.target.value)}
                    onBlur={() => zeileSpeichern(zeile)}
                  />
                  <button className="ta-icon-btn ta-icon-btn-rot" title="Zeile löschen" onClick={() => zeileLoeschen(zeile)}>
                    <span className="material-symbols-outlined">delete</span>
                  </button>
                </div>

                {/* Mini-Vorschau der Zeile (7–24 Uhr) */}
                <div className="ta-vorschau">
                  {zeile.Slots.map((slot) => {
                    const links = zeitZuProzent(slot.Start);
                    const breite = Math.max(zeitZuProzent(slot.Ende) - links, 0.5);
                    return (
                      <div
                        key={slot.ID}
                        className="ta-vorschau-slot"
                        style={{ left: `${links}%`, width: `${breite}%`, backgroundColor: slot.Farbe }}
                        title={`${slot.Start}–${slot.Ende}`}
                      />
                    );
                  })}
                </div>

                {/* Zeitslots bearbeiten */}
                {zeile.Slots.map((slot) => (
                  <div className="ta-slot-editor" key={slot.ID}>
                    <input
                      type="time"
                      value={slot.Start}
                      onChange={(e) => slotLokalAendern(zeile.ID, slot.ID, 'Start', e.target.value)}
                    />
                    <span className="ta-bis">–</span>
                    <input
                      type="time"
                      value={slot.Ende}
                      onChange={(e) => slotLokalAendern(zeile.ID, slot.ID, 'Ende', e.target.value)}
                    />
                    <div className="ta-farben">
                      {FARBEN.map((farbe) => (
                        <button
                          key={farbe.wert}
                          className={`ta-farbe ${slot.Farbe === farbe.wert ? 'active' : ''}`}
                          style={{ backgroundColor: farbe.wert }}
                          title={farbe.name}
                          onClick={() => slotLokalAendern(zeile.ID, slot.ID, 'Farbe', farbe.wert)}
                        />
                      ))}
                    </div>
                    <input
                      type="text"
                      className="ta-slot-label-input"
                      placeholder="Beschriftung (optional)"
                      value={slot.Label || ''}
                      onChange={(e) => slotLokalAendern(zeile.ID, slot.ID, 'Label', e.target.value)}
                    />
                    <button
                      className={`ta-icon-btn ${slot.dirty ? 'ta-icon-btn-gruen' : ''}`}
                      title="Slot speichern"
                      onClick={() => slotSpeichern(slot)}
                    >
                      <span className="material-symbols-outlined">save</span>
                    </button>
                    <button className="ta-icon-btn ta-icon-btn-rot" title="Slot löschen" onClick={() => slotLoeschen(slot)}>
                      <span className="material-symbols-outlined">delete</span>
                    </button>
                  </div>
                ))}

                <button className="ta-slot-hinzufuegen" onClick={() => slotHinzufuegen(zeile)}>
                  <span className="material-symbols-outlined">add</span>
                  Zeitslot hinzufügen
                </button>
              </div>
            ))}
          </div>
        )}

        {/* Neue Zeile hinzufügen */}
        <div className="ta-neue-zeile">
          <input
            type="text"
            placeholder="Neue Zeile, z.B. Stadtfest"
            value={neueZeileName}
            onChange={(e) => setNeueZeileName(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && zeileHinzufuegen()}
          />
          <button className="btn-save" onClick={zeileHinzufuegen} disabled={!neueZeileName.trim()}>
            <span className="material-symbols-outlined">add</span>
            Zeile hinzufügen
          </button>
        </div>

        {zeilen.length > 0 && (
          <button className="ta-tag-loeschen" onClick={tagLoeschen}>
            <span className="material-symbols-outlined">delete_forever</span>
            Kompletten Tag löschen
          </button>
        )}

        {successMsg && (
          <SuccessModal message={successMsg} onClose={() => setSuccessMsg('')} />
        )}
      </div>
    </KernteamLayout>
  );
}

export default TagesablaufVerwaltung;
